import React from 'react';
import Modal from '../components/Shell/Modal';

export default () => {
	return <Modal name="addAttributes" title="Add Attributes Group"></Modal>;
};
